import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message, Select } from 'antd';

import { onPressLogout } from 'src/helpers/rest';
import { setUserData } from 'src/redux/slices/timer';
import API from 'src/apis';

import Input from 'src/components/atoms/input';
import MobileNavigation from 'src/components/organisms/mobile_navigation';

import profilePlaceholder from 'src/assets/images/profile_placeholder.png';
import cameraIcon from 'src/assets/images/camera.svg';
import logoutIcon from 'src/assets/images/logout.svg';
import creditIcon from 'src/assets/images/credits.png';

import styles from './index.module.scss';
import { SUBSCRIPTION_CONST } from 'src/common/constants';
import ContactInput from 'src/components/atoms/contact_input';

const languages = [
    { label: 'English', value: 'en' },
    { label: 'Hindi', value: 'hi' },
    { label: 'Gujarati', value: 'gu' },
    { label: 'Assamese', value: 'as' },
    { label: 'Bengali', value: 'bn' },
    { label: 'Kannada', value: 'kn' },
    { label: 'Kashmiri', value: 'ks' },
    { label: 'Konkani', value: 'kok' },
    { label: 'Malayalam', value: 'ml' },
    { label: 'Manipuri', value: 'mni' },
    { label: 'Marathi', value: 'mr' },
    { label: 'Nepali', value: 'ne' },
    { label: 'Oriya', value: 'or' },
    { label: 'Punjabi', value: 'pa' },
    { label: 'Sanskrit', value: 'sa' },
    { label: 'Sindhi', value: 'sd' },
    { label: 'Tamil', value: 'ta' },
    { label: 'Telugu', value: 'te' },
    { label: 'Urdu', value: 'ur' },
    { label: 'Bodo', value: 'sit' },
    { label: 'Santali', value: 'sat' },
    { label: 'Maithili', value: 'mai' },
    { label: 'Dogri', value: 'doi' },
];

const ProfilePage: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let userData = JSON.parse(localStorage.getItem('userDetails') as string);
    if ((userData?.subscribed_plan ?? []).includes(SUBSCRIPTION_CONST.TATVA_AI_PRO_MONTHLY) || (userData?.subscribed_plan ?? []).includes(SUBSCRIPTION_CONST.TATVA_AI_PRO_YEARLY)) {
        userData = {
            ...userData,
            credit: 'Unlimited'
        }
    }

    const [width, setWidth] = useState(window.innerWidth);
    const [userProfile, setUserProfile] = useState<any>(userData);
    const [isPaymentEnabled, setIsPaymentEnabled] = useState<boolean>(true); // Default to true for PROD, can be set based on API response

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        getUserProfile();
        fetchPaymentStatusConfig();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onChangeInputField = (event: React.ChangeEvent<HTMLInputElement>) => {
        // const { name, value } = event.target;
    };

    const getUserProfile = async () => {
        try {
            let { data: userProfile = null } = await API.GetProfile();
            if (userProfile) {
                if ((userProfile.subscribed_plan ?? []).includes(SUBSCRIPTION_CONST.TATVA_AI_PRO_MONTHLY) || (userProfile.subscribed_plan ?? []).includes(SUBSCRIPTION_CONST.TATVA_AI_PRO_YEARLY)) {
                    userProfile = {
                        ...userProfile,
                        credit: 'Unlimited',
                    };
                }
                setUserProfile(userProfile);
                localStorage.setItem('userDetails', JSON.stringify(userProfile));
                dispatch(setUserData(userProfile));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const onChangeLang = async (e: any) => {
        try {
            const userProfile = JSON.parse(localStorage.getItem('userDetails') as string);
            userProfile.voice_lang = e;

            await API.UpdateVoiceLang({ language: e });
            setUserProfile({ ...userProfile, voice_lang: e });
            localStorage.setItem('userDetails', JSON.stringify(userProfile));
        } catch (error) {
            console.log(error);
            message.error({ content: 'Failed to update voice language!' });
        }
    };

    const fetchPaymentStatusConfig = async () => {
        try {
            // Disabled for PROD only
            // const paymentStatusConfigData = await API.GetPaymentStatusConfig();
            // setIsPaymentEnabled(paymentStatusConfigData.is_payment_enable || false);

            setIsPaymentEnabled(true); // For PROD, set to true
        } catch (error) {
            console.log(error);
            message.error({ content: 'Failed to fetch payment status config!' });
        }
    };

    const goTOSubscription = () => {
        navigate('/my-subscription');
    };

    return (
        <div className={styles.profile_page}>
            <div className={styles.profile_page_wrapper}>
                {width < 900 &&
                    <div className={styles.mobile_profile_header}>
                        <img className={styles.mobile_logout_icon} src={logoutIcon} onClick={onPressLogout} alt='logout' />
                        <span className={styles.mobile_profile_heading}>Edit Profile</span>
                        {/* <span className={styles.mobile_profile_save}>Save</span> */}
                    </div>
                }

                {/* {width > 900
                    && <img className={styles.logout_icon} src={logoutIcon} onClick={onPressLogout} alt='logout' />
                } */}
                <div className={styles.profile_content_container} >
                    <div className={styles.profile_image_wrappper}>
                        <div className={styles.profile_image}>
                            {/* <img src={profilePlaceholder} alt='profile_image' /> */}
                            <img
                                src={userProfile?.profile_image || profilePlaceholder}
                                alt='profile_image'
                                style={!userProfile?.profile_image ? { height: '100%' } : {}}
                                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                    (e.currentTarget as HTMLImageElement).src = profilePlaceholder;
                                    (e.currentTarget as HTMLImageElement).style.height = '100%';
                                }}
                            />
                            <img src={cameraIcon} className={styles.camera_icon} alt='camera_icon' />
                        </div>
                    </div>

                    <div className={styles.profile_input_wrapper}>
                        {(!userProfile?.pm_id || userProfile?.subscribed_plan?.length > 0) && <>
                            {!!(userProfile?.credit === 'Unlimited' && userProfile?.used_tokens !== 0)
                                ? <div className={styles.credit_container}>
                                    {width > 900 && <img src={creditIcon} height={'32px'} alt='credit' />}
                                    <div className={styles.credit_block}>
                                        {width <= 900 && <img src={creditIcon} height={'25px'} alt='credit' />}
                                        <div>
                                            <span className={styles.credit_title_text}>AI Credits - </span>
                                            <span className={styles.credit_text}>Unlimited</span>
                                        </div>
                                    </div>
                                    <div className={styles.credit_block} style={{ width: '165px' }}>
                                        <div>
                                            <span className={styles.credit_title_text} style={{ textAlign: 'start' }}>Credits used - </span>
                                            <span className={styles.credit_text}>{parseInt((userProfile?.used_tokens / 1000).toString())}</span>
                                        </div>
                                    </div>
                                </div>
                                : <div className={styles.credit_wrapper}>
                                    <img src={creditIcon} height={'25px'} alt='credit' />
                                    <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'start' }}>
                                        <div>
                                            <span className={styles.credit_title_text}>AI Credits left - </span>
                                            <span className={styles.credit_text}>{(userProfile?.credit < 0 ? 0 : userProfile?.credit) || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </>}

                        <Input
                            name={'user_name'}
                            label={'User name'}
                            placeholder={'Type user name...'}
                            onChange={(e) => onChangeInputField(e)}
                            disabled
                            value={userProfile?.first_name
                                ? userProfile?.first_name + (userProfile?.last_name ? ' ' + userProfile?.last_name : '')
                                : null}
                        />
                        <div className={styles.phone_number_input}>
                            <span className={styles.phone_number_label}>Phone</span>
                            {/* <span className={styles.country_code}>+91</span>
                            <input
                                name='phone'
                                className={styles.phone_input_field}
                                placeholder='Phone...'
                                disabled
                                value={userProfile?.mobile?.substring(2) || null}
                            /> */}
                            <ContactInput
                                inputClass={styles.phone_input_field}
                                placeholder="-"
                                disabled={true}
                                value={userProfile?.mobile?.substring(2) || null}
                                onChange={(e) => { }}
                            />
                        </div>
                        <Input
                            name={'email'}
                            label={'Email'}
                            placeholder={'Type email...'}
                            onChange={(e) => onChangeInputField(e)}
                            disabled
                            value={userProfile?.email || null}
                        />
                        <div className={styles.phone_number_input}>
                            <span className={styles.phone_number_label}>Select Language For Text to Speech</span>
                            <Select
                                placeholder={'Select voice language'}
                                className={styles.select_field}
                                options={languages}
                                onChange={onChangeLang}
                                value={languages.find(lang => lang.value === (userProfile?.voice_lang || 'en'))}
                            />
                        </div>
                        {isPaymentEnabled && (
                            <div className={styles.subscription_text} style={{ fontSize: '14px' }}>
                                <span>Click here to manage subscription </span>
                                <span className={styles.t} onClick={goTOSubscription}>My Subscription</span>
                            </div>
                        )}
                        {/* <Input
                        name={'email'}
                        label={'Credit Points'}
                        placeholder={'Credit points'}
                        onChange={() => {}}
                        disabled
                        value={userProfile?.email || null}
                    /> */}
                    </div>
                </div>
                {/* {width > 900 &&
                    <button className={styles.save_button}>
                        Save
                    </button>
                } */}
                {width < 900 && <MobileNavigation />}
            </div>
        </div>
    )
}

export default ProfilePage;